export default (jsonObject) => {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(JSON.stringify(jsonObject));
  }
};
